/* WegMug – optiekiezer productkaart (snippets/rd-buy.liquid) */
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    let vs;
    try { vs = JSON.parse(root.querySelector('[data-rd-json]').textContent); } catch (e) { return; }
    const D = root.dataset;
    const L = {
      per: D.tPer || 'per raam',
      pp: D.tPp || ' p/raam',
      save: D.tSave || 'Je bespaart {s} t.o.v. {k}× los kopen',
      best: D.tBest || 'Voordeligst',
      unavail: D.tUnavail || 'Niet beschikbaar',
      sold: D.tSold || 'Uitverkocht'
    };
    const form = root.closest('form') || root.parentElement;
    const loc = D.locale && D.locale !== 'nl' ? D.locale : 'nl-NL';
    const nf = new Intl.NumberFormat(loc, { style: 'currency', currency: D.currency || 'EUR' });
    const money = (c) => nf.format(c / 100);
    const n = (s) => parseInt(String(s).replace(/[^0-9]/g, ''), 10) || 1;
    const qi = Number(D.qty);
    const hide = D.hide === 'true';
    const groups = [...root.querySelectorAll('.rd-opt')];
    const idEl = root.querySelector('[data-rd-id]');
    const priceEl = form.querySelector('[data-rd-price]');
    const perEl = form.querySelector('[data-rd-per]');
    const saveEl = form.querySelector('[data-rd-save]');
    const btn = form.querySelector('[data-rd-add]');
    const btnLabel = form.querySelector('[data-rd-add-label]');
    const img = form.querySelector('[data-rd-img]');
    const vt = form.querySelector('[data-rd-vtitle]');

    // Foto's van alle kleuren alvast laden, zodat wisselen direct gaat
    [...new Set(vs.map((v) => v.m).filter(Boolean))].forEach((src) => { const i = new Image(); i.src = src; });

    const sel = () => groups.map((g) => (g.querySelector('input:checked') || {}).value);
    const find = (o) => vs.find((v) => v.o.every((x, i) => x === o[i]));
    const swap = (o, i, val) => o.map((x, j) => (j === i ? val : x));

    // Prijs van 1 raam bij de huidige maat/kleur (basis voor korting en besparing)
    const unit = (o) => {
      if (qi < 0) return 0;
      let best = null;
      groups[qi].querySelectorAll('input').forEach((inp) => {
        const v = find(swap(o, qi, inp.value));
        const k = n(inp.value);
        if (v && (!best || k < best.k)) best = { k, u: v.p / k };
      });
      return best ? best.u : 0;
    };

    const update = () => {
      const o = sel();
      const v = find(o);
      const u = unit(o);

      groups.forEach((g, i) => {
        const out = g.querySelector('[data-rd-optval]');
        if (out) out.textContent = o[i] || '';
        g.querySelectorAll('.rd-pill').forEach((pill) => {
          const alt = find(swap(o, i, pill.querySelector('input').value));
          pill.classList.toggle('is-off', !alt || !alt.a);
        });
      });

      if (qi >= 0 && !hide) {
        let bestPill = null;
        let bestD = 0;
        groups[qi].querySelectorAll('.rd-pill').forEach((pill) => {
          const val = pill.querySelector('input').value;
          const k = n(val);
          const alt = find(swap(o, qi, val));
          const sub = pill.querySelector('[data-rd-sub]');
          const badge = pill.querySelector('[data-rd-badge]');
          pill.classList.remove('is-best');
          if (!alt) { if (sub) sub.textContent = ''; if (badge) badge.hidden = true; return; }
          const per = alt.p / k;
          const d = u ? Math.round((1 - per / u) * 100) : 0;
          if (sub) sub.textContent = k > 1 ? `${money(alt.p)} · ${money(Math.round(per))}${L.pp}` : money(alt.p);
          if (badge) { badge.hidden = d < 1; badge.textContent = `−${d}%`; }
          if (d > bestD) { bestD = d; bestPill = pill; }
        });
        if (bestPill) { bestPill.classList.add('is-best'); bestPill.dataset.best = L.best; }
      }

      if (vt) vt.textContent = o.join(' · ');
      if (!v) {
        if (btn) btn.disabled = true;
        if (btnLabel) btnLabel.textContent = L.unavail;
        return;
      }
      if (idEl) idEl.value = v.id;
      if (img && v.m && img.getAttribute('src') !== v.m) img.src = v.m;
      if (btn) btn.disabled = !v.a;
      if (btnLabel && btn) btnLabel.textContent = v.a ? btn.dataset.label : L.sold;
      if (hide) return;

      const k = qi >= 0 ? n(o[qi]) : 1;
      if (priceEl) priceEl.textContent = money(v.p);
      if (perEl) perEl.textContent = k > 1 ? `${money(Math.round(v.p / k))} ${L.per}` : L.per;
      if (saveEl) {
        const s = u ? Math.round(u * k - v.p) : 0;
        saveEl.hidden = !(k > 1 && s > 0);
        if (s > 0) saveEl.textContent = L.save.replace('{s}', money(s)).replace('{k}', k);
      }
    };

    root.addEventListener('change', update);
    update();
  };

  const run = () => document.querySelectorAll('[data-rd-picker]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();